import { useUserStore } from '~/stores/auth';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (err, _vm, info) => {
    console.error('Global Vue Component Error:', err, info);

    if (import.meta.env.PROD) {
      const piniaUser = useUserStore();

      if (piniaUser.user?.nonEecUser) {
        clearError({ redirect: '/403' });
        return;
      }

      // Handle specific error logic
      if (err && typeof err === 'object') {
        const errorStatus = err?.status || err?.response?.status; // Support Axios-like errors or custom status

        if (errorStatus >= 400 && errorStatus < 500) {
          // Ignore client-side errors (e.g., 400-level errors)
          console.warn('Client-side error occurred:', errorStatus, err);
        } else {
          // Handle all other errors (e.g., >=500 or undefined status)
          console.log('Unexpected or critical error:', errorStatus, err);
          clearError({ redirect: '/500' });
        }
      } else {
        // Handle errors without a clear status (e.g., runtime errors)
        console.log('Unstructured or unknown error type:', err);
        clearError({ redirect: '/500' });
      }
    }
  });

  nuxtApp.hook('app:error', (err) => {
    console.error('Global Nuxt Error:', err);

    if (import.meta.env.PROD) {
      const statusCode = err?.statusCode || err?.status;
      clearError({ redirect: statusCode === 404 ? '/404' : '/500' });
    }
  });
});
